import { GamsesActiveContainer } from "../containers/gamesActive"

export const GamsesActive = () => {
    return (
        <GamsesActiveContainer />
    )
}